import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { userEnums } from '@vectronic/openApi-customer';
import { isHigherOrEqualToReader, roleRank } from '@vectronic/util';

@Component({
  selector: 'table-datatable-tooltip',
  templateUrl: './datatable-ids-tooltip.component.html',
  styleUrls: ['./datatable-ids-tooltip.component.scss'],
  imports: [CommonModule, OverlayModule, MatCardModule],
})
export class DatatableIdsTooltipComponent {
  row = input<any>();
  isOpen = signal(false);

  sortedCollars = computed(() => {
    if (!this.row()) {
      return [];
    }
    return [...this.row().collarIds].sort((a, b) => {
      const permissionDiff = this.permissionRank(a) - this.permissionRank(b);
      if (permissionDiff !== 0) {
        return permissionDiff;
      }
      return b - a;
    });
  });

  private permissionRank(collarId: number): number {
    const role = this.collarRole(collarId);
    if (!this.isActiveRole(role)) return 4;
    return -roleRank(role);
  }

  private hoverCount = 0;
  private closeTimeout: any = null;

  roleClass(collarId: number) {
    const role = this.collarRole(collarId);
    if (this.isActiveRole(role)) return role;

    if (this.row()?.collarRoles) return 'role-none';
  }

  private collarRole(collarId: number): string | undefined {
    return this.row()?.collarRoles?.[String(collarId)];
  }

  private isActiveRole(role: string | undefined): role is userEnums.Role {
    return Boolean(role && isHigherOrEqualToReader(role as userEnums.Role));
  }

  onMouseOver() {
    this.hoverCount++;
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    this.isOpen.set(true);
  }

  onMouseOut() {
    this.hoverCount--;
    if (this.hoverCount <= 0) {
      this.closeTimeout = setTimeout(() => {
        this.isOpen.set(false);
        this.hoverCount = 0;
        this.closeTimeout = null;
      }, 100);
    }
  }
}
